import(/* webpackMode: "eager" */ "/codebuild/output/src4078610204/src/src/app/page.tsx");
